import {Dimensions, Platform} from 'react-native';

const {width, height} = Dimensions.get('window');

//Guideline sizes are based on standard ~5" screen mobile device
const guidelineBaseWidth = 350;
const guidelineBaseHeight = 680;

const scale = size => width / guidelineBaseWidth * size;
const verticalScale = size => height / guidelineBaseHeight * size;
const moderateScale = (size, factor = 0.5) => Platform.OS === "web" ? size : ((size + (scale(size) - size) * factor) - (size > 3 ? (Platform.OS === "android" ? 2 : 1) : 0));

export {scale, verticalScale, moderateScale};
